export default {
    transferList: {
        selectBytTasks: "Выбрать задачи быта",
        byt: "быт",
        selectPromTasks: "Выбрать задачи прома",
        prom: "пром",
        selectAll: "Выбрать все",
        noSelectedElementsOperationError: "Нельзя выполнить операцию без выбора элементов",
        unselect: "Снять выделение",
    }
}